













































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import PageRequest from '@/store/entities/page-request'
    import AbpBase from '../../lib/abpbase'
    import Ajax from '../../lib/ajax'
    import OrderManagement from '../../store/entities/ordermanagement'
     //点击企业信息查看订单
    class PageordermanagementRequest extends PageRequest{
        keyword:string='';
        stime:Date;
        etime:Date;
        ordtime: Date[] = [];
        status:number=-1;
        type:number=4;
        ordlist:object;
        ordloading:false;
         totalcnt:0;
        pSize:10;
        pPage:1;
        curpage:1
    }
    
    @Component
    export default class Ord extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop( {type:Number}) cid:number;


        companyinformation:OrderManagement=new OrderManagement();


        
        pagerequest:PageordermanagementRequest=new PageordermanagementRequest();

        ordlist:[];
        ordloading:boolean=false;
        totalcnt:number=0;
        pSize:number=10;
        pPage:number=1;
        curpage:number=1;
    /*
     data() {
        return {
        ordlist:[],
        ordloading:false,
        totalcnt:0,
        pSize:10,
        pPage:1,
        curpage:1
    
        }
     }*/
       
       
        save(){
            
        }
       

        cancel(){
            (this.$refs.companyinformationForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
              
            if(!value){
                this.$emit('input',value);
            }else{
                  
                //document.getElementsByClassName("ivu-modal-footer").namedItem.prototype.delete;
                
              this.getpage();
                
            }
           
            
        }
     

       get list(){
          // var lt= this.getpage();
          //  console.log("1")
            return this.ordlist;
        };
        get loading(){
            return this.ordloading;
        }

        

         pageChange(page:number){
           // this.$store.commit('ordermanagement/setCurrentPage',page);
            this.curpage=page;
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('ordermanagement/setPageSize',pagesize);
            this.getpage();
        }
          getpage(){

            var ordtime=this.pagerequest.ordtime;
            let skipCount=0;
            let maxResultCount=this.pSize;
            skipCount=(this.curpage-1)*this.pSize;
           if (ordtime.length > 0) {
            this.pagerequest.stime = this.pagerequest.ordtime[0];
    }
    if (this.pagerequest.ordtime.length > 1) {
           this.pagerequest.etime = this.pagerequest.ordtime[1];
    }
             

             var th=this;
             var parmas={ type:1,status:-1,maxResultCount:maxResultCount,skipCount:skipCount,cid:this.cid,stime:this.pagerequest.stime,etime:this.pagerequest.etime};
            
            let reponse=  Ajax.get('/api/services/app/OrderManagement/GetAll',{params:parmas});
            this. ordloading=true;
            let page= reponse. then(function (response) {
            let dt=  response.data.result
             
             th.totalcnt=dt.totalCount;
             th.ordlist=dt.items;
             th.ordloading=false;
            })
           
            
        }
         


        get pageSize(){
              return this.pSize;
        }
        get totalCount(){
            return this.totalcnt;
        }
        get currentPage(){
            return this.pPage;
        }
        columns=[{
            title:this.L('OrderNo'),
            key:'orderno'
        }
        ,{
            title:this.L('OrderType'),
           //key:'type'
              width:100,
            render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.ordertype;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.type){
                            statustxt=this.L(lstst[i].name)
                            
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        }
        
        ,{
            title:this.L('OrderWeight'),
            key:'weight',
            width:100
        }
        
,{
            title:this.L('CompanyinformationName'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
               
                   var name="";
                if(params.row.companyInformation!=null){
                      name=params.row.companyInformation.name;
                }    
                return h('span',name)
            }
        }
      ,{
            title:this.L('WasteTypeName'),
           
             render:(h:any,params:any)=>{
                //console.log(params.row)
                var wdname="";
                //params.row.  wasteType.wdname
                if(params.row.  wasteType!=null){
                      wdname=params.row.  wasteType.wdname;
                }   
                return h('span',wdname)
            }
        }
      
        
        ,{
            title:this.L('OrderOperators'),
            key:'operators',
               width:120

        },{
            title:this.L('OrderStatus'),
           width:120,
             render:(h:any,params:any)=>{
                  var statustxt="";
                  var lstst=this.$store.state.ordermanagement.statuslist;
                   for(let i=0;i<lstst.length;i++){

                       if(lstst[i].id==params.row.status){
                            statustxt=this.L(lstst[i].name)
                             
                             
                         }
                   }
                      return    h('span',statustxt);
             }
        } 
        ,{
            title:this.L('OrderTime'),
           // key:'orderTime'
             render:(h:any,params:any)=>{
                //console.log(params.row)
                return h('span',new Date(params.row.ordertime).toLocaleString())
            }
        }
        
 
        ]
        created() {
          
        }

        

         
        
    }
